import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import AsyncState from "../../core/asyncState"
import { SystemError } from "../../core/error"
import { ChannelDto, ChannelNames } from "../../models/channel"
import { WebhooksPrefixes } from "../../models/parameterDeclaration"
import { ChannelScenario } from "../../models/scenario"
import { resetReducerState } from "../action"

export type ChannelsState = Readonly<{
    createChannel: AsyncState<void>
    updateChannel: AsyncState<void>
    deleteChannel: AsyncState<void>
    webhooksPrefixes: AsyncState<WebhooksPrefixes>
    channelNames: AsyncState<ChannelNames>
    channelScenario: AsyncState<ChannelScenario>
    channelsDataWithoutConfigs: AsyncState<ChannelDto[]>
}>

const initialState: ChannelsState = {
    createChannel: AsyncState.create(),
    updateChannel: AsyncState.create(),
    deleteChannel: AsyncState.create(),
    webhooksPrefixes: AsyncState.create(),
    channelNames: AsyncState.create(),
    channelScenario: AsyncState.create(),
    channelsDataWithoutConfigs: AsyncState.create()
}

const channels = createSlice({
    name: "channels",
    initialState,
    reducers: {
        createChannelProcess(state) {
            state.createChannel = state.createChannel.toProcess()
        },
        createChannelSuccess(state) {
            state.createChannel = state.createChannel.toSuccess()
        },
        createChannelFailed(state, action: PayloadAction<SystemError>) {
            state.createChannel = state.createChannel.toFailed(action.payload)
        },
        updateChannelProcess(state) {
            state.updateChannel = state.updateChannel.toProcess()
        },
        updateChannelSuccess(state) {
            state.updateChannel = state.updateChannel.toSuccess()
        },
        updateChannelFailed(state, action: PayloadAction<SystemError>) {
            state.updateChannel = state.updateChannel.toFailed(action.payload)
        },
        deleteChannelProcess(state) {
            state.deleteChannel = state.deleteChannel.toProcess()
        },
        deleteChannelSuccess(state) {
            state.deleteChannel = state.deleteChannel.toSuccess()
        },
        deleteChannelFailed(state, action: PayloadAction<SystemError>) {
            state.deleteChannel = state.deleteChannel.toFailed(action.payload)
        },
        getWebhooksPrefixesProcess(state) {
            state.webhooksPrefixes = state.webhooksPrefixes.toProcess()
        },
        getWebhooksPrefixesSuccess(state, action: PayloadAction<WebhooksPrefixes>) {
            state.webhooksPrefixes = state.webhooksPrefixes.toSuccess(action.payload)
        },
        getWebhooksPrefixesFailed(state, action: PayloadAction<SystemError>) {
            state.webhooksPrefixes = state.webhooksPrefixes.toFailed(action.payload)
        },
        getChannelsNamesProcess(state) {
            state.channelNames = state.channelNames.toProcess()
        },
        getChannelsNamesSuccess(state, action: PayloadAction<ChannelNames>) {
            state.channelNames = state.channelNames.toSuccess(action.payload)
        },
        getChannelsNamesFailed(state, action: PayloadAction<SystemError>) {
            state.channelNames = state.channelNames.toFailed(action.payload)
        },
        getChannelScenarioProcess(state) {
            state.channelScenario = state.channelScenario.toProcess()
        },
        getChannelScenarioSuccess(state, action: PayloadAction<ChannelScenario>) {
            state.channelScenario = state.channelScenario.toSuccess(action.payload)
        },
        getChannelScenarioFailed(state, action: PayloadAction<SystemError>) {
            state.channelScenario = state.channelScenario.toFailed(action.payload)
        }
    },
    extraReducers(builder) {
        builder.addCase(resetReducerState, () => {
            return initialState
        })
    }
})

export const ChannelsReducer = channels.reducer

export const actions = channels.actions
